import type { PaymentMethodPrice } from '@eti/schema-types';
import { css, mediaQueries } from '@eti/styles';

export const getPaymentMethods = (paymentMethodPrices: PaymentMethodPrice[]) =>
  paymentMethodPrices?.map((method: PaymentMethodPrice) => {
    return {
      ...method,
      label: method.name,
      price: method?.price?.value ?? 0,
      value: method?.price?.value ?? 0,
    };
  });

export const priceInfoCommonStyles = (isLongCurrency: boolean, isMultipleTickets: boolean) => css`
  @media ${mediaQueries.small.only} {
    ${!isLongCurrency && isMultipleTickets && `align-items: center;`}
    ${isMultipleTickets && 'flex-direction: row;'};
    gap: 4px;
    ${isLongCurrency && `flex-direction:column; align-items: flex-start;`}
    ${isLongCurrency && `p{margin:0}`}
  }
`;
